export function trimToLastWord(text, maxLength) {
    if (text.length <= maxLength) return text;  
    let trimmed = text.substring(0, maxLength + 1);  
    trimmed = trimmed.substring(0, trimmed.lastIndexOf(" "));  
    return trimmed + "...";
}